
import { Component, EventEmitter, Output } from '@angular/core';
import {SlideshowService} from './../../slideshow.service';
import { Utils } from '../../../utils';

@Component({
    selector: 'content',
    templateUrl: 'content.component.html'
})
export class PreviewContentComponent {
    @Output('loaded') loaded = new EventEmitter();
    constructor(public slideshow: SlideshowService, public utils: Utils) {}
    ngAfterViewInit() {
        this.loaded.emit(true);
    }
}